import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let receivable_id = useDataValue({
    viewPath: props.viewPath,
    context: 'receivable',
    path: 'id',
  })

  return {
    variables: {
      receivable_id,
    },
    // Note: adding or modifying receivables is only available through old UI
    // we may be able to change it to cache-only once everything is added through the new UI so it reflects the changes automatically
    requestPolicy: 'cache-and-network',
  }
}
